import Cookies from "js-cookie";

import router from "@/router";

export class MarketingTracking {
  static appendUtmParameters(formData: FormData) {
    [
      "utm_campaign",
      "utm_content",
      "utm_medium",
      "utm_source",
      "utm_term",
    ].forEach((field) => {
      const route = router.currentRoute.value;
      if (Reflect.get(route.query, field)) {
        formData.append(field, Reflect.get(route.query, field) as string);
      }
    });
  }

  static appendReferrerId(formData: FormData) {
    const route = router.currentRoute.value;
    if (Reflect.get(route.query, "ref")) {
      formData.append(
        "referred_code",
        Reflect.get(route.query, "ref") as string
      );
    } else if (Cookies.get("jb_ref")) {
      formData.append("referred_code", Cookies.get("jb_ref") || "");
    }
  }

  static appendReferrerUrl(formData: FormData) {
    const route = router.currentRoute.value;
    if (Reflect.get(route.query, "referrer_url")) {
      formData.append(
        "referral_url",
        Reflect.get(route.query, "referrer_url") as string
      );
    } else if (Cookies.get("jb_referrer_url")) {
      formData.append("referral_url", Cookies.get("jb_referrer_url") || "");
    }
  }

  static appendFacebookClickId(formData: FormData) {
    const route = router.currentRoute.value;
    if (Reflect.get(route.query, "fbclid")) {
      formData.append("fbclid", Reflect.get(route.query, "fbclid") as string);
    } else if (Cookies.get("jb_fbclid")) {
      formData.append("fbclid", Cookies.get("jb_fbclid") || "");
    }
  }

  static appendGoogleClientId(formData: FormData) {
    if (Cookies.get("_ga")) {
      formData.append("gtag_client_id", Cookies.get("_ga")?.substring(6) ?? "");
    }
  }
}
